export enum CaseNotificationEvent {
  APP_NOTIFICATION = "socket_event_app_notification",
  NEW_CASE_CREATED = "socket_event_new_case_created",
  CASE_ASSIGNMENT_STATUS_UPDATED = "socket_event_case_assignment_status_updated",
  CASE_TAG_UPDATED = "socket_event_case_tag_updated",
  CASE_CHAT_MESSAGE = "socket_event_case_chat_message",
  CASE_ASSIGNMENT_UPDATED = "socket_event_case_assignment_updated",
  CASE_REOPENED = "socket_event_case_reopened",
  CASE_DETAIL_UPDATED = "socket_event_case_detail_updated",
  ASSIGNMENT_REMOVED = "socket_event_case_assignment_removed",
  REPORT_LOCK_ACQUIRED = "report_lock_acquired",
  REPORT_LOCK_RELEASED = "report_lock_released",
  REPORT_DRAFT_UPDATED = "report_draft_updated",
}
